import { validateEmail } from "../config/utils";

export const feeFromName = (fees, name) => {
    if (fees && name) {
        const selectedFees = fees.filter(f => f.name === name);
        if (selectedFees) return selectedFees[0];
    }
    return null;
}

export const getFeeTotal = (selectedFees, selectedOption) => {
    let total = 0;
    if (selectedFees) {
        selectedFees.forEach(f => total += f.amount)
    }
    if (selectedOption && selectedOption.amount > 0) {
        total += selectedOption.amount;
    }
    return total;
}

export const getContactResponse = (form, phoneVal, zipVal, internalAgency, posPayments) => {
    const response = {};
    const payor = {};
    const trimmedEmail = form.email ? form.email.trim() : '';
    let errors = '';
    if (!form.payorName) {
        errors += 'The payor name is required';
    } else {
        payor.name = form.payorName;
    }
    if (form.partyName) {
        payor.partyName = form.partyName;
    }
    if (!internalAgency) {
        if (!form.address) {
            if (errors.length > 5) errors += '; ';
            errors += 'A contact address is required';
        }
        if (!form.city) {
            if (errors.length > 5) errors += '; ';
            errors += 'A contact city is required';
        }
        if (!form.state) {
            if (errors.length > 5) errors += '; ';
            errors += 'A contact state is required';
        }
        if (!zipVal || !zipVal.value) {
            if (errors.length > 5) errors += '; ';
            errors += 'A postal code is required';
        } else if (zipVal.value.length !== 5) {
            if (errors.length > 5) errors += '; ';
            errors += 'The zip code is invalid';
        }
        if (!form.email && (!phoneVal || !phoneVal.value)) {
            if (errors.length > 5) errors += '; ';
            errors += 'Either a valid email address or phone number must be entered';
        }
    }
    payor.address = form.address;
    payor.city = form.city;
    payor.state = form.state;
    payor.zip = zipVal ? zipVal.value : '';
    if (trimmedEmail && !validateEmail(trimmedEmail)) {
        if (errors.length > 5) errors += '; ';
        errors += 'The email address is invalid';
    } else {
        payor.email = form.email;
    }
    if (phoneVal && phoneVal.value && phoneVal.value.length < 10) {
        if (errors.length > 5) errors += '; ';
        errors += 'The phone number is invalid';
    } else if (phoneVal) {
        payor.phone = phoneVal.formattedValue;
    }
    if (errors.length > 5) {
        response.error = true;
        response.errorMessage = errors;
    } else {
        response.payor = payor;
    }
    return response;
}

export const getFeesPaymentRequest = (courtId, contactInfo, selectedFees, selectedOption, feeTotal, processingFee) => {
    if (selectedOption) {
        selectedFees.push({
            cmsId: selectedOption.cmsId,
            name: selectedOption.name,
            amount: selectedOption.amount,
            quantity: 1,
            itemAmount: selectedOption.amount,
            deliveryMethod: true,
            comments: selectedOption.description
        });
    }
    return {
        courtId: courtId,
        paymentDescription: getFeesPaymentDescription(selectedFees),
        processingType: 'miscFees',
        partyName: contactInfo.partyName ? contactInfo.partyName : contactInfo.name,
        payorName: contactInfo.name,
        payorAddress: contactInfo.address,
        payorCity: contactInfo.city,
        payorState: contactInfo.state,
        billingZip: contactInfo.zip,
        email: contactInfo.email,
        phone: contactInfo.phone,
        totalAmount: feeTotal + processingFee,
        courtAmount: feeTotal,
        feeAmount: processingFee,
        payor: contactInfo,
        miscellaneousFees: selectedFees
    };
}

export const getFeesPaymentDescription = (selectedFees) => {
    const fees = selectedFees.filter(f => !f.deliveryMethod);
    return `Miscellaneous fees: ${fees[0].name.substring(0, 25)}`;
}